import { statList } from "@/mocks/content";

export default function Hero() {
  return (
    <section id="home" className="relative flex min-h-[640px] w-full flex-col justify-center overflow-hidden md:min-h-[720px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20vibrant%20anime%20cityscape%20at%20sunset%20with%20floating%20light%20orbs%20and%20warm%20coral%20orange%20and%20teal%20gradient%20sky%2C%20cinematic%20wide%20shot%2C%20atmospheric%20depth%2C%20clean%20artistic%20composition%2C%20no%20text%2C%20high%20quality%20digital%20illustration&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="小猴看番多线路聚合播放平台视觉背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/75"></div>
      </div>

      <div className="container-site relative z-10 w-full py-24 md:py-28">
        <div className="mx-auto flex max-w-3xl flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-sm text-background-50 backdrop-blur-sm">
            <i className="ri-stack-line text-secondary-300" aria-hidden="true"></i>
            自动选源 · 秒切线路 · 多源播放
          </span>

          <h1 className="mt-6 font-heading text-4xl font-bold leading-tight text-background-50 md:text-6xl">
            多线路聚合
            <span className="text-secondary-300">,</span>
            <br className="hidden md:block" />
            告别看番卡顿
          </h1>

          <p className="mt-6 max-w-xl text-base leading-relaxed text-background-100/90 md:text-lg">
            小猴看番聚合 1200+ 播放源,自动选源与手动秒切线路结合,备用线路随时切换,热门新番老番都能快速找到可播线路,稳定追更不掉链子。
          </p>

          <div className="mt-9 flex flex-col items-center gap-3 sm:flex-row">
            <a href="#anime" className="btn-primary w-full px-8 py-3.5 text-base sm:w-auto">
              <i className="ri-play-fill mr-1" aria-hidden="true"></i>
              立即看番
            </a>
            <a href="#guide" className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-8 py-3.5 text-base font-semibold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20 sm:w-auto">
              <i className="ri-map-pin-2-line mr-1" aria-hidden="true"></i>
              线路切换指南
            </a>
          </div>
        </div>

        <div className="mx-auto mt-14 grid max-w-4xl grid-cols-2 gap-4 rounded-2xl border border-background-50/20 bg-background-50/10 p-6 backdrop-blur-md sm:grid-cols-4">
          {statList.map((stat) => (
            <div key={stat.label} className="flex flex-col items-center gap-1 text-center">
              <span className="font-heading text-2xl font-bold text-secondary-300 md:text-3xl">{stat.value}</span>
              <span className="text-sm text-background-100/80">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>

      <a
        href="#features"
        className="absolute bottom-6 left-1/2 z-10 -translate-x-1/2 flex h-10 w-10 items-center justify-center rounded-full border border-background-50/30 text-background-50/80 transition-colors hover:text-background-50"
        aria-label="向下滚动查看核心功能"
      >
        <i className="ri-arrow-down-line" aria-hidden="true"></i>
      </a>
    </section>
  );
}